module.exports = __webpack_public_path__ + "img/ipassmoney.e931ad93.png";